import { Navigate, useLocation } from "react-router-dom";
import { useAuthMe } from "../hooks/useAuth";
import { Login } from "../pages/Login";

export const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { data, isLoading, isError } = useAuthMe();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-gray-500">
        Checking sign-in…
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-2 p-8 text-center">
        <p className="text-sm text-red-600">Could not reach the server.</p>
      </div>
    );
  }

  if (data?.authRequired && !data.authenticated) {
    if (location.pathname === "/login") return <Login />;
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (location.pathname === "/login") {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
